import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import AddEmployeeComponent from '../components/AddEmployeeComponent'

const mapStateToProps = (state) => {
  return {
    employee: state.employee,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEmployeeComponent)
